import { render } from "./PatientWorkflowDialog.vue?vue&type=template&id=1720bcce&scoped=true"
import script from "./PatientWorkflowDialog.vue?vue&type=script&lang=js"
export * from "./PatientWorkflowDialog.vue?vue&type=script&lang=js"

import "./PatientWorkflowDialog.vue?vue&type=style&index=0&id=1720bcce&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1720bcce"]])

export default __exports__